// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__E1KaX","alertIcon":"ConfirmModal_alertIcon__gxNY_"};